import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './Navbar/NavBar';
import videoFile from '../video/video.mp4';

const Home = () => {
    return (
        <>
        
            <div className="hero" id='home'>
                <div>
                    <NavBar />
                </div>

                <div className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 h-5/6" data-aos="zoom-in">

<div
  id="hero"
  className="relative flex flex-col lg:flex-row py-8 min-h-screen items-center justify-center overflow-hidden text-center lg:text-left"
>
  {/* Video de fondo */}
  <video
    className="absolute top-10 left-0 w-full h-full object-cover"
    src={videoFile}
    autoPlay
    loop
    muted
    playsInline
  />

  {/* Overlay oscuro */}
  <div className="absolute top-10 left-0 w-full h-full bg-black/40"></div>

  {/* Contenido */}
  <div className="relative z-10 lg:w-1/2 flex flex-col justify-center px-6">


    <h1 className="mb-5 md:text-5xl text-3xl font-bold text-white">
      A cleaner home for the moments that matter most.
    </h1>

    <div className="mb-4 md:mb-8">
      <Link
        to="/contact"
        className="text-white font-bold bg-red-900 hover:bg-red-800 inline-flex items-center justify-center px-6 py-3 text-lg shadow-xl rounded-2xl"
      >
        Contact Us
      </Link>
    </div>
  </div>
</div>
                </div>
            </div>
        </>
    )
}

export default Home;